import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "absolute z-30 h-10 w-screen flex justify-between top-0 mt-2 px-2" }

import LockButton from './LockButton.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    isLocked: { type: Boolean }
  },
  emits: ['toggle-lock'],
  setup(__props: any, { emit }) {




return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(LockButton, {
      locked: __props.isLocked,
      onToggleLock: _cache[0] || (_cache[0] = ($event: any) => (emit('toggle-lock')))
    }, null, 8, ["locked"])
  ]))
}
}

})